import { create } from "zustand";

const useAdminStore = create((set, get) => ({
    role: null, // 'admin' | 'superadmin' | null
    company: null,
    setRole: (role) => set({ role }),
    setCompany: (company) => set({ company }),
    clear: () => set({ role: null, company: null }),
    isAdmin: () => get().role === "admin",
    isSuperAdmin: () => get().role === "superadmin",
}));

export default useAdminStore;


